import { useState, useEffect } from 'react';

export interface Branding {
  part1: string;
  part2: string;
  logoUrl: string | null;
  showBlock: boolean;       // legacy — true if either header or login is shown
  showBlockHeader: boolean; // brand block in the nav bar (post-login)
  showBlockLogin: boolean;  // brand block on the login/auth page
  showAuthLinks: boolean;
  showPosts: boolean;
  showQR: boolean;
  showMap: boolean;
  showBirthday: boolean;
  loginBannerText: string;
  loginBannerEnabled: boolean;
}

const DEFAULT: Branding = { part1: 'BROOD', part2: 'book', logoUrl: null, showBlock: true, showBlockHeader: true, showBlockLogin: true, showAuthLinks: false, showPosts: true, showQR: true, showMap: true, showBirthday: true, loginBannerText: '', loginBannerEnabled: false };

// Module-level cache so multiple components on the same page share one fetch
let cache: Branding | null = null;
const listeners: Array<() => void> = [];

async function fetchBranding() {
  try {
    const res = await fetch('/api/auth/branding', { credentials: 'include' });
    const json = await res.json();
    if (json.success) {
      cache = { ...DEFAULT, ...json.data };
      listeners.forEach(fn => fn());
    }
  } catch {}
}

export function useBranding(): Branding {
  const [branding, setBranding] = useState<Branding>(cache ?? DEFAULT);

  useEffect(() => {
    const update = () => setBranding(cache ?? DEFAULT);
    listeners.push(update);

    if (!cache) fetchBranding();
    else update();

    // Refresh when admin makes a change (same-tab event)
    const onChanged = () => { cache = null; fetchBranding(); };
    window.addEventListener('brand-name-changed', onChanged);

    return () => {
      listeners.splice(listeners.indexOf(update), 1);
      window.removeEventListener('brand-name-changed', onChanged);
    };
  }, []);

  return branding;
}
